import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

import "./SidebarNavItemPurger.css";

const SidebarNavItemPurger = ({projectId, handleOpenPurgeModal}) => {
  return (
    <div
      className="sidebar-nav-item-purge d-flex align-items-center justify-content-center"
      onClick={() => handleOpenPurgeModal(projectId)}
    >
      <FontAwesomeIcon
        className="sidebar-nav-item-purge-icon"
        icon={faTrash}
      />
    </div>
  );
};

export default SidebarNavItemPurger;
